import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { trackButtonClick } from "../../utils/analytics";
import { setLoginTab, setLoginCallLocation } from "../../redux/login/loginSlice";
import "./MobileAppAds.css";
import useAuth from "./header/useAuth";

const MobileAppAds = ({ cmsData }) => {
  const dispatch = useDispatch();

  const {isUserLoggedIn} = useAuth()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div id="mobile-app-ads" className="modern-apertment-home">
      <div id="mobile-app-ads-container" className=" discover-stats-container">
        <div id="mobile-app-content" className="modern-apartment-container">
          <div id="mobile-app-left" className="modern-apartment-left">
            <div id="mobile-app-text" className="mobile-ads p50">
              <div id="mobile-app-title" className="title">
                {cmsData?.app?.header}
              </div>
              <div id="mobile-app-description" className="description">
                {cmsData?.app?.description}
              </div>
              <br />
              <Link
                id="mobile-app-register-btn"
                to={isUserLoggedIn ? "#" : "/register-sign-in"}
                className={`btn btn-lg hubzu-btn-thm register-free ${isUserLoggedIn ? 'register-free-disabled' : ''}`}
                onClick={(e) => {
                  if (isUserLoggedIn) {
                    e.preventDefault();
                  } else {
                    dispatch(setLoginTab("regsiterTab"));
                    dispatch(setLoginCallLocation("login"));
                  }
                }}
              >
                Register For Free
              </Link>
              <a
                id="mobile-app-google-play-btn"
                href={cmsData?.app?.googlePlayStore}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackButtonClick({
                    eventName: "app_download_click",
                    eventCategory: "Home Page 2.0",
                    eventSource: "Google play store click",
                    eventLabel: `Google play store | Section position: 6`,
                    eventParams: { store: "google_play" },
                  });
                }}
              >
                <img
                  id="mobile-app-google-play-img"
                  className="downloads"
                  src={isMobile ? "/assets/images/home/socialGoogleAppBtnMobileView.png" : "/assets/images/home/socialGoogleAppBtn.webp"}
                  alt="Download on Google Play"
                />
              </a>
              <a
                id="mobile-app-apple-store-btn"
                href={cmsData?.app?.appleStore}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackButtonClick({
                    eventName: "app_download_click",
                    eventCategory: "Home Page 2.0",
                    eventSource: "Apple Store click",
                    eventLabel: `Apple App store | Section position: 6`,
                    eventParams: { store: "apple_app_store" },
                  });
                }}
              >
                <img
                  id="mobile-app-apple-store-img"
                  className="downloads"
                  src={isMobile ? "/assets/images/home/socialAppleAppBtnMobileView.png" : "/assets/images/home/socialAppleAppBtn.webp"}
                  alt="Download on App Store"
                />
              </a>
            </div>
          </div>
          <img
            id="mobile-app-phone-img"
            className="iphone-img-home"
            src={isMobile ? "/assets/images/home/registerFree-mobile.jpg" : "/assets/images/home/registerFree.webp"}
            alt="Hubzu mobile app"
          />
        </div>
      </div>
    </div>
  );
};

export default MobileAppAds;